// extracted by mini-css-extract-plugin
export default {"Container":"SubCompCommodity_Container__3heEV","Loading":"SubCompCommodity_Loading__OX3YX","Tip_float":"SubCompCommodity_Tip_float__YrL4z"};